import { render, staticRenderFns } from "./ResumeDetail.vue?vue&type=template&id=edd63806&"
import script from "./ResumeDetail.vue?vue&type=script&lang=js&"
export * from "./ResumeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports